

const PageReload = () => {

    return (
        <div className="spinner-border fs-1 m-auto mt-5 pt-5 d-block" role="status"
            style={{width:"200px",height:"200px", color:"#00c8d5"}}
        >
            <span className="visually-hidden">Loading...</span>
        </div>
    )
}

export default PageReload;